<template>
	<v-container id="jtron" fluid pa-0>
		<div id="jtron-bg" />

		<v-layout justify-center align-center>
			<v-flex xs11 sm9 md8 lg6 xl4>
				<app-jumbotron-intro />
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import AppJumbotronIntro from '@/components/AppJumbotronIntro'

export default {
	components: { AppJumbotronIntro },

	data: () => ({
		counter: 0,
		duration: 5000,
		pictures: [
			'aska-hallway-01.jpg',
			'aska-hallway-02.jpg',
			'aska-hallway-03.jpg',
			//'aska-hallway-04.jpg',
			//'aska-hallway-05.jpg',

			'aska-infant-01.jpg',
			'aska-infant-02.jpg',
			'aska-infant-03.jpg',
			'aska-infant-04.jpg',
			'aska-infant-05.jpg',

			'aska-waddler-01.jpg',
			'aska-waddler-02.jpg',

			'aska-toddler-01.jpg',
			'aska-toddler-02.jpg',
			'aska-toddler-03.jpg',
			'aska-toddler-04.jpg',
			'aska-toddler-05.jpg',

			'aska-prek1-01.jpg',
			'aska-prek1-02.jpg',
			'aska-prek1-03.jpg',

			'aska-bacare-01.jpg',
			'aska-bacare-02.jpg',

			'aska-prek2-01.jpg',

			'aska-complab-01.jpg',

			'aska-tutorhw-01.jpg',

			'aska-playground-01.jpg',
			'aska-playground-02.jpg',
			'aska-playground-03.jpg',
		],
	}),

	created() {
		clearInterval(this.interval)

		this.interval = setInterval(() => {
			const self = this
			$('#jtron-bg').fadeTo('slow', 0.0, function() {
				$(this).css('background-image', 'url(/img/pics/' + self.nextImg() + ')')
			}).fadeTo('slow', 1)
		}, this.duration)
	},

	destroyed() {
		clearInterval(this.interval)
	},

	methods: {
		incCounter() {
			this.counter++
			if (this.counter >= this.pictures.length) {
				this.counter = 0
			}
			return this.counter
		},

		nextImg() {
			return this.pictures[this.incCounter()]
		},
	},
}
</script>

<style>
#jtron {
	position: relative;
}
@media(min-width: 600px) {
	#jtron .layout {
		padding: 10rem 0;
	}
}
#jtron-bg {
	background-image: url(/img/pics/aska-hallway-01.jpg);
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>
